import React from 'react';
import header from '../../Components/Header/Header.module.css';
import '../../Components/Page/Page.css';

import Footer from '../../Components/Footer/FooterSmall';
import TeamSection from './TeamSection';
import Header2 from '../../Components/Header2/Header2';

const Leadership: React.FC = () => {
  return (
    <div className='generalPage'>
      <Header2 />
      <div className='pageContainer2'>
        <TeamSection />
      </div>
      <Footer />
    </div>

  );
};

export default Leadership;